import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidUnlockAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17 9H9V7c0-.8.3-1.5.9-2.1 1.2-1.2 3.1-1.2 4.2 0 .4.4.6.9.8 1.4.1.5.7.8 1.2.7.5-.1.9-.7.7-1.2-.2-.9-.7-1.7-1.3-2.3-.9-1-2.2-1.5-3.5-1.5-2.8 0-5 2.2-5 5v2c-1.7 0-3 1.3-3 3v7c0 1.7 1.3 3 3 3h10c1.7 0 3-1.3 3-3v-7c0-1.7-1.3-3-3-3Zm-4 8c0 .6-.4 1-1 1s-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v3Z"/>
  </SvgIcon>
}

export default SolidUnlockAltIcon
